<template>
	<div>
		<div class="container">
			<div class="handle-box">
				<el-select size="small" @change="agentChange" v-model="query.agentId" clearable filterable
					placeholder="代理商" class="handle-input mr10" style="width: 260px;">
					<el-option v-for="item in agents" :key="item.value" :label="item.label"
						:value="item.value"></el-option>
				</el-select>
				<el-select size="small" v-model="query.companyId" clearable filterable placeholder="企业"
					class="handle-input mr10" style="width: 260px;">
					<el-option v-for="item in companys" :key="item.value" :label="item.label"
						:value="item.value"></el-option>
				</el-select>
				<el-select size="small" v-model="query.cardsId" filterable clearable placeholder="请选择品牌"
					class="handle-input mr10">
					<el-option v-for="item in cardsList" :key="item.label" :label="item.value"
						:value="item.label"></el-option>
				</el-select>
				<el-input size="small" v-model="query.phoneNumber" clearable placeholder="手机号" class="handle-input mr10"
					style="width: 180px;"></el-input>
				<el-input size="small" v-model="query.randomNumber" clearable placeholder="请输入批次号"
					class="handle-input mr10" style="width: 180px;"></el-input>
				<el-button size="small" type="primary" :class="[theme]" icon="el-icon-search"
					@click="handleSearch">搜索</el-button>
				<el-button size="small" type="primary" :class="[theme]" @click="showForm2">添加报备号码</el-button>
				<el-button size="small" type="primary" :class="[theme]" icon="el-icon-delete  el-icon--right"
					@click="batchDel">批量删除</el-button>
				<el-button size="small" type="primary" :class="[theme]" icon="el-icon-upload2  el-icon--right"
					@click="exportData">导出</el-button>
			</div>
			<el-row :gutter="20" type="flex" class="row-bg">
				<el-col :span="24">
					<el-table :data="tableData" border class="table" ref="multipleTable" max-height="600"
						header-cell-class-name="table-header" :row-style="{ height: '20px' }" v-loading="loading"
						:cell-style="{ padding: '6px' }" :header-cell-style="{ 'text-align': 'center' }"
						@selection-change="handleSelectionChange" stripe>
						<el-table-column prop="agent" label="代理商" align="center"></el-table-column>
						<el-table-column prop="company" label="企业" align="center"></el-table-column>
						<el-table-column prop="phoneNumber" label="电话号码" align="center"></el-table-column>
						<el-table-column prop="cardType" label="品牌" align="center"></el-table-column>
						<el-table-column prop="randomNumber" label="批次号" align="center"></el-table-column>
						<el-table-column prop="date" label="添加时间" align="center"></el-table-column>
						<el-table-column label="操作" align="center">
							<template #default="scope">
								<el-button size="small" type="text" icon="el-icon-delete" style="color: #f56c6c;"
									@click="handleDelete(scope.$index, scope.row.id)">删除</el-button>
							</template>
						</el-table-column>
					</el-table>
				</el-col>
			</el-row>
			<div class="pagination">
				<el-pagination background layout="total, sizes, prev, pager, next, jumper"
					:current-page="query.pageIndex" :page-sizes="[10, 20, 50, 100, 200, 500]"
					:page-size="query.pageSize" :total="pageTotal" @size-change="handleSizeChange"
					@current-change="handlePageChange"></el-pagination>
			</div>
		</div>

		<div class="report-number">
			<el-dialog title="添加报备号码" v-model="upload" width="650px" :close-on-click-modal="false">
				<el-upload ref="upload" action="/api/blackList/addReportNumber" :headers="token" :limit="1"
					:on-success="uploadSuccess" :on-preview="handlePreview" :on-remove="handleRemove"
					:auto-upload="false" :data="uploadData">
					<el-button size="small" type="primary" :class="[theme]" style="margin-top: 40px;">选择文件</el-button>
				</el-upload>
				<el-button size="small" style="margin: 10px 0 0 80%;" type="primary" :class="[theme]"
					v-loading.fullscreen.lock="loading" @click="submitUpload">确定上传</el-button>
			</el-dialog>
		</div>
		<div class="report-number">
			<el-dialog title="批量删除" v-model="deleteVisible" width="650px" :close-on-click-modal="false">
				<el-form :model="deleteForm" ref="deleteForm" label-width="120px">
					<el-form-item label="删除号码">
						<el-input size="small" type="textarea" :rows="5" placeholder="一行一个号码,一次最多添加100个号码"
							v-model="deleteForm.phones"></el-input>
					</el-form-item>
					<el-form-item class="dis-end">
						<el-button size="small" @click="deleteVisibleClose">取消</el-button>
						<el-button size="small" type="primary" :class="[theme]" v-loading.fullscreen.lock="loading"
							@click="batchDel2">确定删除</el-button>
					</el-form-item>
				</el-form>
			</el-dialog>
		</div>
		<el-dialog title="手动添加" v-model="addVisible" width="650px" :close-on-click-modal="false">
			<el-form :model="addForm" ref="addForm" label-width="120px">
				<el-form-item label="代理" prop="agent">
					<el-select size="small" @change="agentChange" v-model="addForm.agentId" filterable clearable
						placeholder="代理商" style="width: 100%;">
						<el-option v-for="item in agents" :key="item.value" :label="item.label"
							:value="item.value"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="企业" prop="company">
					<el-select size="small" v-model="addForm.companyId" filterable clearable placeholder="企业"
						style="width: 100%;">
						<el-option v-for="item in companys" :key="item.value" :label="item.label"
							:value="item.value"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="品牌" prop="cardsId">
					<el-select size="small" v-model="addForm.cardsId" filterable placeholder="请选择品牌"
						style="width: 100%;">
						<el-option v-for="item in cardsList" :key="item.label" :label="item.value"
							:value="item.label"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="添加号码">
					<el-input size="small" type="textarea" :rows="5" placeholder="一行一个号码,一次最多添加100个号码"
						v-model="addForm.phones"></el-input>
				</el-form-item>
				<el-form-item class="dis-end">
					<el-button size="small" @click="addVisibleClose">取消</el-button>
					<el-button size="small" type="primary" :class="[theme]" @click="getAddReport">确定上传</el-button>
				</el-form-item>
			</el-form>
		</el-dialog>
	</div>
</template>

<script>
	import {
		getReportNumberList,
		deleteReportNumber,
		getReportCompany,
		downloadReportNumber
	} from '../../api/reportNumber.js';
	import {
		getCardType
	} from '../../api/cardType.js';
	import {
		fetchDefaultCompanies,
		fetchCompanyByAgentId,
		addReport
	} from '../../api/companyIndex';
	import {
		fetchAgent
	} from '../../api/agentIndex';
	export default {
		name: 'reportNumber',
		data() {
			return {
				loading: false,
				theme: localStorage.getItem('theme'),
				theme3: localStorage.getItem('theme3'),
				theme8: localStorage.getItem('theme8'),
				deleteVisible: false,
				deleteForm: {
					phones: ''
				},
				query: {
					phoneNumber: '',
					pageIndex: 1,
					pageSize: 10,
					agentId: '',
					randomNumber: '',
					companyId: '',
					cardsId: ''
				},
				token: {
					Authorization: localStorage.getItem('token'),
					type: 'web',
					UserRole: localStorage.getItem('ms_role'),
					XSecurityVersion: 'v2'
				},
				tableData: [],
				delList: [],
				agents: [],
				companys: [],
				pageTotal: 0,
				form: {
					phoneNumber: ''
				},

				upload: false,
				path: process.env.BASE_URL,
				multipleSelection: [],
				addForm: {
					phones: '',
					cardsId: '',
					agentId: '',
					companyId: ''
				},
				addVisible: false,
				cardsList: [],
				companysList: []
			};
		},
		created() {
			this.getCardTypes();
			this.init();
			this.getData();
			this.updatePaginationStyle();
		},
		methods: {
			updatePaginationStyle(){
				let pagination = document.getElementById('pagination');
				if (!pagination) {
					pagination = document.createElement('style');
					pagination.id = 'dynamic-tab-style';
					document.head.appendChild(pagination);
				}
				pagination.innerHTML = `
				    .el-pager .active {
				        background-color: ${this.theme8} !important;
						color: #fff !important;
				    }
					.el-pager .number:hover {
				        color: ${this.theme8} !important;
				    }
					.el-pager .active:hover {
					    color: #fff !important;
					}
					.el-pager .more:hover {
					    color: ${this.theme8} !important;
					}
				`;
			},
			companyChange(agent) {
				if (agent) {
					let data = {
						agent: agent,
					};
					getReportCompany(data).then(res => {
						this.companysList = res.data;
					});
				} else {
					this.query.companyId = '';
					this.addForm.companyId = '';
				}
			},

			getData() {
				let data = {
					phoneNumber: this.query.phoneNumber.replaceAll(' ', ''),
					agentId: this.query.agentId,
					randomNumber: this.query.randomNumber,
					companyId: this.query.companyId,
					cardsId: this.query.cardsId,
					pageSize: this.query.pageSize,
					pageIndex: this.query.pageIndex,
					userId: localStorage.getItem('user'),
				};
				this.loading = true;
				getReportNumberList(data).then(res => {
					this.loading = false;
					if (res?.code === 200) {
						this.tableData = res.data.list;
						this.pageTotal = res.data.total;
					} else {
						this.$message.error(res.message);
					}
				});
			},
			showForm() {
				this.upload = true;
			},

			// 触发搜索按钮
			handleSearch() {
				this.query.pageIndex = 1;
				this.getData();
			},
			exportData() {
				this.loading = true;
				let str = '';
				this.delList = this.delList.concat(this.multipleSelection);
				for (let i = 0; i < this.delList.length; i++) {
					str += this.delList[i].id + ',';
				}

				this.query.ids = str;
				this.query.userId = localStorage.getItem('user');
				downloadReportNumber(this.query).then(res => {
					const blob = new Blob([res], {
						type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8'
					});
					let downloadElement = document.createElement('a');
					let href = window.URL.createObjectURL(blob);
					downloadElement.href = href;
					let fileName = '报备绿名单号码' + '.xls';
					downloadElement.download = fileName;
					document.body.appendChild(downloadElement);
					downloadElement.click();
					document.body.removeChild(downloadElement);
					window.URL.revokeObjectURL(href);
					this.loading = false;
				});
			},
			/* 批量删除 */
			batchDel() {
				let str = '';
				this.delList = this.delList.concat(this.multipleSelection);
				for (let i = 0; i < this.delList.length; i++) {
					str += this.delList[i].id + ',';
				}
				if (str === '') {
					this.deleteVisible = true;
				} else {
					let param = {
						ids: str,
						userId: localStorage.getItem('user'),
					};
					// 二次确认删除
					this.$confirm('确定要删除吗？', '提示', {
							type: 'warning'
						})
						.then(() => {
							deleteReportNumber(param).then(res => {
								if (res?.code === 200) {
									this.$message.success('批量删除成功');
									this.getData();
								} else {
									this.$message.error(res.message);
								}
							});
						})
						.catch(() => {});
				}

				this.multipleSelection = [];
			},
			batchDel2() {
				let param = {
					phones: this.deleteForm.phones,
					userId: localStorage.getItem('user'),
				};
				deleteReportNumber(param).then(res => {
					if (res?.code === 200) {
						this.deleteVisible = false;
						this.deleteForm.phones = '';
						this.$message.success('批量删除成功');
						this.getData();
					} else {
						this.$message.error(res.message);
					}
				});
			},
			deleteVisibleClose() {
				this.deleteVisible = false;
				this.deleteForm.phones = '';
			},
			// 多选操作
			handleSelectionChange(val) {
				this.multipleSelection = val;
			},
			// 删除操作
			handleDelete(index, id) {
				// 二次确认删除
				this.$confirm('确定要删除吗？', '提示', {
						type: 'warning'
					})
					.then(() => {
						let data = {
							ids: id,
							userId: localStorage.getItem('user'),
						};
						deleteReportNumber(data).then(res => {
							if (res?.code === 200) {
								this.$message.success('删除成功');
								this.getData();
							} else {
								this.$message.error(res.message);
							}
						});
					})
					.catch(() => {});
			},
			submitUpload() {
				if (this.$refs.upload.uploadFiles[0]) {
					this.loading = true;
					this.$refs.upload.submit();
				} else {
					this.$message.error('请选择上传文件');
				}
			},
			uploadSuccess(success) {
				setTimeout(() => {
					this.loading = false;
					this.$refs.upload.clearFiles();
				}, 2000);
				if (success?.code === 200) {
					this.$message.success('上传成功');
					this.upload = false;
				} else {
					// this.open(success.message);
					this.$message.error(success.message);
				}
			},
			// 分页导航
			handlePageChange(val) {
				this.query.pageIndex = val;
				this.getData();
			},
			handleSizeChange(val) {
				this.query.pageSize = val;
				this.query.pageIndex = 1; // 重置到第一页
				this.getData();
			},
			resetForm(formName) {
				this.$refs[formName].resetFields();
			},
			showForm2() {
				this.addVisible = true;
				this.addForm.cardsId = '';
				this.addForm.phones = '';
				this.addForm.agentId = '';
				this.addForm.companyId = '';
			},
			getCardTypes() {
				getCardType('').then(res => {
					this.cardsList = res.data;
				});
			},
			getAddReport() {
				let data = {
					userId: localStorage.getItem('user'),
					phones: this.addForm.phones,
					cardsId: this.addForm.cardsId,
					agentId: this.addForm.agentId,
					companyId: this.addForm.companyId,
				};
				addReport(data).then(res => {
					if (res?.code === 200) {
						this.$message.success(res.data);
						this.addVisible = false;
						this.getData();
					} else {
						this.$message.error(res.message);
					}
				});
			},
			addVisibleClose() {
				this.addVisible = false;
			},
			agentChange(agentId) {
				//代理商下拉
				if (agentId) {
					let data = {
						subAgent: JSON.parse(localStorage.getItem('subAgent').toLowerCase()),
						agentId: agentId
					};
					if (localStorage.getItem('webName') == '橙逸通信') {
						let data = {
							subAgent: false,
							agentId: agentId
						};
						fetchCompanyByAgentId(data).then(res => {
							this.companys = res.data;
						});
					} else {
						let data = {
							subAgent: JSON.parse(localStorage.getItem('subAgent').toLowerCase()),
							agentId: agentId
						};
						fetchCompanyByAgentId(data).then(res => {
							this.companys = res.data;
						});
					}
				}
			},
			init() {
				fetchAgent(localStorage.getItem('user')).then(res => {
					//代理
					this.agents = res.data;
					this.options = res.data;
				});
				let data1 = {
					currentUserId: localStorage.getItem('user')
				};
				fetchDefaultCompanies(data1).then(res => {
					//默认企业
					this.companys = res.data;
				});
			},
		}
	};
</script>

<style scoped>
	.handle-box {
		margin-bottom: 50px;
	}

	/* a:hover{background: #66b1ff} */
	.handle-select {
		width: 240px;
	}

	.table {
		width: 100%;
		font-size: 12px;
	}

	.red {
		color: #f56c6c;
	}

	.mr10 {
		margin-right: 10px;
	}

	.mr100 {
		position: absolute;
		right: 100px;
	}

	.myRight {
		position: absolute;
		right: 10px;
		bottom: 10px;
	}

	.handle-input {
		width: 200px;
		display: inline-block;
	}

	.down {
		border: 1px solid #dcdfe6;
		background: #4f7afd;
		color: #ffffff;
		transition: 0.1s;
		font-weight: 500;
		padding: 6px 16px;
		font-size: 12px;
		border-radius: 4px;
		margin-left: 10px;

		display: inline-block;
	}
</style>

<style>
	.report-number .el-upload {
		width: 100% !important;
		display: flex !important;
		flex-direction: column !important;
		align-items: center !important;
		justify-content: center !important;
	}

	.report-number .btn {
		background-color: #4f7afd;
		margin-top: 20px;
		display: flex;
		flex-direction: row;
		justify-content: flex-end;
		border: none;
		margin-left: 80%;
	}
</style>